import { Profile, isProfile, checkProfile } from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useDocumentStore } from "Helpers/StoreHelper";
import { useRef } from "react";
import { firestore } from "firebase/app";

export function useProfileStore(userId?: string) {
  const collectionRef = useRef(firestore().collection(CollectionPath.PROFILES));

  return useDocumentStore<Profile>({
    check: checkProfile,
    is: isProfile,
    collection: collectionRef.current,
    documentPath: userId,
  });
}
